// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_K2b","colBig":"styles_colBig__2GdEi","colSmall":"styles_colSmall__2KBL1"};